import styled from 'styled-components'

const Inner = styled.div`
  padding: 30px 35px;
`

export const s = { Inner }
